module.exports = __webpack_public_path__ + "static/mask-symbol-DND3_FnP-5e76bde14a334bde73d85dd72fff7d6c.webp";